/* STOCK BOY theme — small enhancements. Everything also works without JavaScript. */
(function () {
  // Filters and sorting on collection pages apply as soon as something changes.
  document.addEventListener('change', function (event) {
    var form = event.target.form;
    if (form && form.id === 'FilterForm') {
      form.submit();
    }
  });

  // Close the mobile menu with Escape or when tapping outside it.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.mobile-menu[open]').forEach(function (menu) {
      menu.removeAttribute('open');
      var summary = menu.querySelector('summary');
      if (summary) summary.focus();
    });
  });

  document.addEventListener('click', function (event) {
    document.querySelectorAll('.mobile-menu[open]').forEach(function (menu) {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
  });
})();
